import { Component } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {WaiterService} from "../../core/http/waiter.service";
import {tap} from "rxjs";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AuthService} from "../../core/auth/auth.service";
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'app-create-waiter',
  templateUrl: './create-waiter.component.html',
  styleUrls: ['./create-waiter.component.scss']
})
export class CreateWaiterComponent {

  userRoles: string[] | null = [];
  superadmin: boolean = false;
  waiterForm!: FormGroup;

  constructor(private fb: FormBuilder, private waiterService: WaiterService, private _snackBar: MatSnackBar, private authService: AuthService) {
    this.userRoles = this.authService.getUserRole();
    if (this.userRoles && <boolean>this.userRoles!.includes('superadmin')) {
      this.superadmin = true;
    }
    this.createForm();
  }

  createForm() {
    this.waiterForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      street: [''],
      houseNumber: [''],
      zip: [''],
      city: [''],
      country: [''],
      mobileNumber: [''],
      email: [''],
      newTenant: [''],
      tenantName: ['']
    });
  }

  onSubmit() {
    if (this.waiterForm.invalid) {
      this._snackBar.open('Bitte Vor- und Nachnamen ausfüllen', 'Schließen', {duration: 3000});
      return;
    }
    this.waiterService.createWaiter(this.waiterForm.value).subscribe(response => {
      this.waiterForm.reset();
      this._snackBar.open('Kellner ' + response.firstName + ' ' + response.lastName + ' erstellt', 'Schließen', {duration: 3000});
    });
  }

  simulateError(): void {
    this.waiterService.simulateError().subscribe(result => {
      // nothing to do here
    });
  }
}
